import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * NOT-567 — the Reminders queue moved out of Marketing into Settings, where it
 * sits next to the per-type reminder configuration. The old
 * `/dashboard/reminders` route redirects to the Queue tab of the Settings screen
 * so bookmarks and the "reminders" palette keyword keep landing on the queue.
 */
export const Route = createFileRoute('/_dashboard/dashboard/reminders')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard/settings/reminders', search: { view: 'queue' } });
  },
});
